import type { ExpensesReport, StockIssuesReport } from '@sellokart/shared';
import { portalApi, queryString } from '@/lib/api';
import type { ReportFilters } from './useReportFilters';

export const expensesReportKeys = {
  expenses: (filters: ReportFilters) => ['reports', 'expenses', filters] as const,
  stockIssues: (filters: ReportFilters) => ['reports', 'stock-issues', filters] as const,
};

/**
 * Both endpoints return their whole result set, so only the branch and range
 * go to the server; search and filters are applied on the page.
 */
function rangeQuery(filters: ReportFilters): string {
  return queryString({ branchId: filters.branchId, from: filters.from, to: filters.to });
}

export function fetchExpensesReport(filters: ReportFilters, signal?: AbortSignal): Promise<ExpensesReport> {
  return portalApi.get<ExpensesReport>(`/portal/reports/expenses${rangeQuery(filters)}`, { signal });
}

export function fetchStockIssuesReport(filters: ReportFilters, signal?: AbortSignal): Promise<StockIssuesReport> {
  return portalApi.get<StockIssuesReport>(`/portal/reports/stock-issues${rangeQuery(filters)}`, { signal });
}
